import { getItem, removeItem, setItem } from './localStorageUtil';
import { LOCAL_STORAGE_KEYS } from '../const/localStorageConst';
import { setForceUpdatePassword } from './forcePasswordUpdate';

const isTruthyAdmin = (value) => value === true || value === 'true' || value === 1 || value === '1';

export const getRedirectPathByRole = (isAdmin) => (isTruthyAdmin(isAdmin) ? '/admin-dashboard' : '/user-dashboard');

export const normalizeAuthResponse = (res) => {
  const payload = res?.data && typeof res.data === 'object' ? res.data : (res || {});
  const userInfo = payload.user_info || payload.userInfo || payload.user || {};
  const username = payload.username
    || payload.user_name
    || payload.account
    || payload.email
    || payload.UserId
    || userInfo.username
    || userInfo.user_name
    || userInfo.account
    || userInfo.email
    || userInfo.UserId
    || '';
  const isAdmin = payload.is_admin ?? payload.isAdmin ?? userInfo.is_admin ?? userInfo.isAdmin ?? false;

  return {
    token: payload.token || payload.auth_token || payload.authToken || '',
    username: username ? String(username) : '',
    pwd: payload.pwd ?? payload.password ?? userInfo.pwd ?? userInfo.password ?? '',
    isAdmin: isTruthyAdmin(isAdmin),
    forceUpdatePassword: payload.force_update_password ?? payload.forceUpdatePassword ?? '1',
    userInfo: {
      ...userInfo,
      username: username ? String(username) : userInfo.username,
      is_admin: isTruthyAdmin(isAdmin),
    },
  };
};

export const saveAuthSession = (res, options = {}) => {
  const normalized = normalizeAuthResponse(res);
  const username = options.username ? String(options.username) : normalized.username;
  const isAdmin = options.isAdmin ?? normalized.isAdmin;
  const userInfo = {
    ...normalized.userInfo,
    username: username || normalized.userInfo.username,
    is_admin: isTruthyAdmin(isAdmin),
  };

  if (!normalized.token) {
    return {
      success: false,
      msg: res?.msg || '登录失败，未获取到登录凭证',
    };
  }

  setItem(LOCAL_STORAGE_KEYS.TOKEN, normalized.token);
  setItem(LOCAL_STORAGE_KEYS.IS_ADMIN, isTruthyAdmin(isAdmin));
  setItem(LOCAL_STORAGE_KEYS.USER_INFO, userInfo);
  setForceUpdatePassword(normalized.forceUpdatePassword ?? '1');

  if (username) {
    const savedUsername = getItem(LOCAL_STORAGE_KEYS.LOGIN_USERNAME);
    setItem(LOCAL_STORAGE_KEYS.LOGIN_USERNAME, username);

    if (options.persistPassword) {
      setItem(LOCAL_STORAGE_KEYS.LOGIN_PWD, options.pwd ?? normalized.pwd ?? '');
    } else if (savedUsername && String(savedUsername) !== username) {
      removeItem(LOCAL_STORAGE_KEYS.LOGIN_PWD);
    }
  }

  return {
    success: true,
    redirectPath: getRedirectPathByRole(isAdmin),
    userInfo,
  };
};

export const savePasswordLoginSession = (res, { username, pwd }) => saveAuthSession(res, {
  username,
  pwd,
  persistPassword: true,
});

export const saveQrLoginSession = (res) => saveAuthSession(res, {
  pwd: normalizeAuthResponse(res).pwd,
  persistPassword: true,
});
